import React, { Component } from 'react';
import { Row, Col } from 'antd';

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <Row justify="center" className="">
        <Col xs={24} md={12} >
            <div className="hero-text">
              <h4>EL INVENTARIO ES ORO</h4>
              <h1>Hacemos que</h1>
              <h1>controlar</h1>
              <h1>Inventarios sea</h1>
              <h1>genial.</h1>
              <img className="imgLine" alt="line" src="./assets/images/linea.png" />
              <div>
                <img className="imgMonta" alt="monta" src="./assets/images/iconMonta.png" />
              </div>
            </div>
            
        </Col>
    </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js